import FormInput from "./formInput/formInput.component";

export {
    FormInput,
}